<script setup lang="ts">
    /**
     * # Grid
     * - implements [style guide](https://www.sketch.com/s/d5c5b81a-6387-4b69-a27e-19a117a47eb4/p/4F632024-3684-4163-BEE1-B9F788E7E5E5/canvas)
     * - < md 2 columns
     * - \>= md 12 columns
     * - span your content accordingly with e.g. `row-span-3`
     */
    declare interface GridProps {
        tag?: string;
        fullWidth?: boolean;
        noMargin?: boolean;
    }
    withDefaults(defineProps<GridProps>(), {
        tag: 'div',
        fullWidth: false,
        noMargin: false,
    });
</script>
<template>
    <component
        :is="tag"
        :class="['atm-grid grid gap-4 lg:gap-6', { 'lg:mx-auto lg:max-w-[960px] xl:max-w-[1200px]': !fullWidth, 'mx-6 md:mx-8': !noMargin }]">
        <slot></slot>
    </component>
</template>
<style scoped>
    .atm-grid {
        @apply grid-cols-2 md:grid-cols-12;
    }
    .no-grid > .atm-grid {
        @apply grid-cols-1;
    }
</style>
